import { useEffect, useState } from "react";

// Top scroll progress bar with gradient and pulse.
export default function ScrollProgress() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      const p = max <= 0 ? 0 : (h.scrollTop / max) * 100;
      setPct(p);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      aria-hidden
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 z-50 h-[3px] pointer-events-none"
    >
      <div
        className="h-full bg-gradient-to-r from-plum via-royal to-violet shadow-[0_0_12px_rgba(143,68,173,0.7)] transition-[width] duration-150 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
